// extracted by mini-css-extract-plugin
export default {"footer-navbar":"footer-navbar_footer-navbar__ofI47","footer-navbar-buttons":"footer-navbar_footer-navbar-buttons__WUmCJ"};